import React from 'react';
import { MultiSelect, Option } from '../../../../../../../components/ui/multi-select';
import { CollapsibleFilterBar } from './CollapsibleFilterBar';

// Gas-specific filter constants
const GAS_STATUS_TYPES = ['Available', 'Consumed'] as const;

interface GasFilters {
  status: string[];
  serialNumber: string[];
  lotNumber: string[];
  manufacturer: string[];
  batchNumber: string[];
}

interface GasFiltersProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  filters: GasFilters;
  onFilterChange: (key: keyof GasFilters) => (value: string[]) => void;
  uniqueSerialNumbers: string[];
  uniqueLotNumbers: string[];
  uniqueManufacturers: string[];
  uniqueBatchNumbers: string[];
  hasActiveFilters: boolean;
  filteredCount: number;
  onResetFilters: () => void;
}

export const GasFilters: React.FC<GasFiltersProps> = ({
  searchQuery,
  onSearchChange,
  filters,
  onFilterChange,
  uniqueSerialNumbers,
  uniqueLotNumbers,
  uniqueManufacturers,
  uniqueBatchNumbers,
  hasActiveFilters,
  filteredCount,
  onResetFilters,
}) => {
  // Convert arrays to options for MultiSelect
  const statusOptions: Option[] = GAS_STATUS_TYPES.map(status => ({
    value: status,
    label: status
  }));

  const serialNumberOptions: Option[] = uniqueSerialNumbers.map(serialNumber => ({
    value: serialNumber,
    label: serialNumber
  }));

  const lotNumberOptions: Option[] = uniqueLotNumbers.map(lotNumber => ({
    value: lotNumber,
    label: lotNumber
  }));

  const manufacturerOptions: Option[] = uniqueManufacturers.map(manufacturer => ({
    value: manufacturer,
    label: manufacturer
  }));

  const batchNumberOptions: Option[] = uniqueBatchNumbers.map(batchNumber => ({
    value: batchNumber,
    label: batchNumber
  }));

  const activeFilterCount =
    filters.status.length +
    filters.serialNumber.length +
    filters.lotNumber.length +
    filters.manufacturer.length +
    filters.batchNumber.length;

  return (
    <CollapsibleFilterBar
      searchQuery={searchQuery}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search materials by serial number, lot number, or details..."
      activeFilterCount={activeFilterCount}
      filteredCount={filteredCount}
      filteredCountLabel="materials"
      onResetFilters={onResetFilters}
    >
      <MultiSelect
        options={statusOptions}
        selected={filters.status}
        onChange={onFilterChange('status')}
        placeholder="Status"
        isSearchable={false}
      />
      <MultiSelect
        options={serialNumberOptions}
        selected={filters.serialNumber}
        onChange={onFilterChange('serialNumber')}
        placeholder="Serial Number"
      />
      <MultiSelect
        options={lotNumberOptions}
        selected={filters.lotNumber}
        onChange={onFilterChange('lotNumber')}
        placeholder="Lot Number"
      />
      <MultiSelect
        options={manufacturerOptions}
        selected={filters.manufacturer}
        onChange={onFilterChange('manufacturer')}
        placeholder="Manufacturer"
      />
      <MultiSelect
        options={batchNumberOptions}
        selected={filters.batchNumber}
        onChange={onFilterChange('batchNumber')}
        placeholder="Batch Number"
      />
    </CollapsibleFilterBar>
  );
}; 